export const LOCAL_STORAGE_PREFIX = '@stellar-payments'
